module.exports = __webpack_public_path__ + "img/IT0000124553903.43e5c9ed.png";